var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNpm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 102,
    viewBox: "0 0 115 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1211 49.9453H57.5V63.3281H51.1211V49.9453Z",
    fill: "#A61111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.5625V76.7344H31.9395V83.4375H57.5V76.7344H115V36.5625H0ZM31.9395 70.0547H25.5605V49.9687H19.1592V70.0547H6.37891V43.2656H31.9395V70.0547ZM63.8789 70.0547H51.0986V76.7578H38.3184V43.2656H63.8789V70.0547ZM108.621 70.0547H102.242V49.9687H95.8633V70.0547H89.4844V49.9687H83.1055V70.0547H70.3252V43.2656H108.666V70.0547H108.621Z",
    fill: "#A61111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpm);
export default __webpack_public_path__ + "static/media/npm.e76a31c49d3d67e720636ddd421552b5.svg";
export { ForwardRef as ReactComponent };